import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "luggageInput",
    "stepInput",
    "priceDisplay",
    "summaryDiv",
    "summaryDisplay",
    "form"
  ]

  calculatePrice() {
    if (!this.formTarget.reportValidity()) return

    const luggageCount = this.luggageInputTarget.value
    const steps = this.stepInputTarget.value

    fetch(`${this.formTarget.action}?luggage_count=${luggageCount}&steps=${steps}`)
      .then(response => response.json())
      .then(data => {
        if (data.price == 0) {
          this.priceDisplayTarget.textContent = I18n.contact_us
        } else {
          this.priceDisplayTarget.textContent = `${data.price.toString().replace(/\.0$/, '')} €`
          this.summaryDisplayTarget.textContent = data.summary
          this.summaryDivTarget.classList.remove("hidden")
        }
      })
      .catch((error) => {
        console.error("Error calculating price:", error)
      })
    }
}

